export default __webpack_public_path__ + "static/spa_b.2967175554d96c1d60a2edabed74656f.png";